import React from 'react';

class DivPermission extends React.Component {

    hasPermission() {
        if (this.props.exclusao) {
            return !this.props.arrayPerm.some(r => this.props.permUser.indexOf(r) >= 0)
        }
        return this.props.arrayPerm.some(r => this.props.permUser.indexOf(r) >= 0)
    }

    render() {
        if (this.hasPermission()) return this.props.children;
        else return <React.Fragment></React.Fragment>;
    }
}

export default DivPermission